import { createNode } from '@glueapp/graph-types';

export const Multiply = createNode({
    id: 'Multiply',
    name: 'Multiply',
    description: 'A Node for multiplying numbers',
    aiDescription:
        'Multiplies two numbers. Connect values to "Number" and "Multiplier" input ports; the "Result" output port provides the product.',
    category: 'Math',
    color: '#5daa5b',
    integration: undefined,
    inPorts: {
        Number: { kind: 'number' },
        Multiplier: { kind: 'number' },
    },
    outPorts: {
        Result: { kind: 'number' },
    },
    execute: function (input) {
        return { output: { Result: input.inPorts.Number * input.inPorts.Multiplier } };
    },
});
